export default __webpack_public_path__ + "static/media/paolo.bca09b04.png";